import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { decodeToken } from "../../utils/auth";

const RequireAuth = () => {
  const accessToken = useSelector((state) => state.auth.accessToken) || "";
  const userStatus = useSelector((state) => state.auth.userStatus) || "";
  const decodedToken = decodeToken(accessToken) || "";
  const isAdmin = decodedToken?.roles?.includes("ROLE_ADMIN");

  const location = useLocation();

  return userStatus === "ACTIVE" && !isAdmin ? (
    <Outlet />
  ) : accessToken && !isAdmin ? (
    <Navigate to="/auth/registration-status" />
  ) : (
    <Navigate to="/auth/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
